module.exports = __webpack_public_path__ + "static/media/category.16f0a085.svg";